import type { TooltipOptions } from '@getaccept/fried-tofu';
import { Placement } from '@getaccept/fried-tofu';

export const toolTipOptions: TooltipOptions = {
  offset: 8,
  delay: { show: 300, hide: 100 },
  placement: Placement.Bottom,
};
